import { render, staticRenderFns } from "./AlertInventoryList.vue?vue&type=template&id=0ed49d9f&scoped=true"
import script from "./AlertInventoryList.vue?vue&type=script&lang=js"
export * from "./AlertInventoryList.vue?vue&type=script&lang=js"
import style0 from "./AlertInventoryList.vue?vue&type=style&index=0&id=0ed49d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed49d9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VTextField})
